<template>
  <Dialog
    width="560px"
    :title="$$t('common.language')"
    :visible="renderData.visible"
    @close="closeDialog"
    :titleAlign="createRenderType === 'mobile' ? 'left' : 'center'"
    mobileRenderType="drawerDialog"
    :customClass="`switch-language-dialog--${createRenderType}`"
  >
    <div class="height-all switch-language-dialog-content flex-column">
      <template
        v-for="(item, index) in LanguageList"
        :key="item.key"
      >
        <div
          class="switch-language-item"
          :class="{
            active: $$language() === item.key,
          }"
          @click="
            () => {
              handleLanguageChange(item);
            }
          "
        >
          <i class="block"></i>

          <span class="block">{{ item.label }}</span>
        </div>
      </template>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import Dialog from "@/components/basic/dialog/Dialog.vue";
import Button from "@/components/basic/button/Button.vue";
import message from "@/components/functionCallComponent/message.jsx";

import { LanguageList } from "@/i18n/i18n.js";
import useUserDataStore from "@/store/userDataStore.js";
const userDataStore = useUserDataStore();

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {};

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(["update:visible"]);

const renderData = reactive({
  visible: props.visible,
});

const closeDialog = () => {
  renderData.visible = false;
};

const handleLanguageChange = (val) => {
  closeDialog();
  nextTick(() => {
    userDataStore.switchLanguage(val.key);
  });
};

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible;
  }
);

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val);
  }
);

const onTabClick = () => {};
onMounted(() => {});
</script>
<style lang="scss" scope>
.switch-language-dialog-content {
  margin: 15px 0 32px 0;
  .switch-language-item {
    align-items: center;
    color: #fff;
    cursor: pointer;
    display: flex;
    font-size: 14px;
    height: 42px;
    list-style: none;
    padding: 0 16px;
    white-space: nowrap;
    align-items: center;
    justify-content: start;
    i {
      width: 20px;
      height: 20px;
      background-image: url("@/assets/img/ratio-select-ico.png");
      background-size: 100% 100%;
    }
    span {
      margin-left: 8px;
    }
    &:hover {
      color: #94adff;
    }
    &.active {
      color: #94adff;
      i {
        background-image: url("@/assets/img/ratio-selected-ico.png");
        background-size: 100% 100%;
      }
      &:hover {
        color: rgba(255, 255, 255, 1);
      }
    }
  }
}
</style>
